"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenAdvisorLiabilityQuizV2QuizType = void 0;
var AvenAdvisorLiabilityQuizV2QuizType;
(function (AvenAdvisorLiabilityQuizV2QuizType) {
    AvenAdvisorLiabilityQuizV2QuizType["ONBOARDING_MORTGAGE_TEXT_BOX_ONLY"] = "onboarding_mortgage_text_box_only";
    AvenAdvisorLiabilityQuizV2QuizType["ONBOARDING_HELOC_TEXT_BOX_ONLY"] = "onboarding_heloc_text_box_only";
    AvenAdvisorLiabilityQuizV2QuizType["ONBOARDING_REVOLVING_CREDIT_CARD_BALANCE_TEXT_BOX_ONLY"] = "onboarding_revolving_credit_card_balance_text_box_only";
})(AvenAdvisorLiabilityQuizV2QuizType || (exports.AvenAdvisorLiabilityQuizV2QuizType = AvenAdvisorLiabilityQuizV2QuizType = {}));
